import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const wheelRewardsWonApi = createApi({
  reducerPath: "wheelRewardsWon",
  tagTypes: ["WheelRewardsWon"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}/tenant/wheelRewardsWon`,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem("access_token");
      const vendorData = JSON.parse(sessionStorage.getItem("vendorData"));
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      if (vendorData?.tenant_id) {
        headers.set("slug", vendorData.tenant_id);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Get all wheel rewards won for a campaign
    getWheelRewardsWon: builder.query({
      query: ({
        wc_id,
        page = 1,
        limit = 10,
        search = "",
        reward_type = "",
        status = "",
      }) => ({
        url: `?wc_id=${wc_id}&page=${page}&limit=${limit}&search=${search}&reward_type=${reward_type}&status=${status}`,
        method: "GET",
      }),
      providesTags: ["WheelRewardsWon"],
    }),

    // Get wheel rewards won by specific user
    getWheelRewardsWonByUser: builder.query({
      query: ({ user_id, page = 1, limit = 10 }) => ({
        url: `/user?user_id=${user_id}&page=${page}&limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["WheelRewardsWon"],
    }),

    // Update wheel reward won status
    updateWheelRewardWonStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/${id}/status`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ["WheelRewardsWon"],
    }),

    // Add cash transfer to bank
    addCashTransferToBank: builder.mutation({
      query: (body) => ({
        url: `/wheel-cash-transfer`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["WheelRewardsWon"],
    }),

    // Approve points reward
    approveWheelPointsReward: builder.mutation({
      query: (id) => ({
        url: `/${id}/approve-points`,
        method: "POST",
      }),
      invalidatesTags: ["WheelRewardsWon"],
    }),
  }),
});

export const {
  useGetWheelRewardsWonQuery,
  useGetWheelRewardsWonByUserQuery,
  useUpdateWheelRewardWonStatusMutation,
  useAddCashTransferToBankMutation,
  useApproveWheelPointsRewardMutation,
} = wheelRewardsWonApi;
